import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { IndicadorCliente } from '../api/dto/indicador-cliente';
import { ProcessoCliente } from '../api/dto/processo-cliente';

@Injectable({
    providedIn: 'root',
})
export class ProcessoClienteService {

    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'processos-clientes/';
    
    buscarPorId(id?: number): Observable<ProcessoCliente> {
        return this.http.get<IndicadorCliente>(this.url + id);
    }

    listarPorCliente(clienteId?: number): Observable<ProcessoCliente[]> {
        return this.http.get<ProcessoCliente[]>(this.url + 'cliente/' + clienteId);
    }

    salvar(processoCliente: ProcessoCliente): Observable<ProcessoCliente> {
        return this.http.post<ProcessoCliente>(this.url, processoCliente);
    }
    atualizar(id?: number, processoCliente?: ProcessoCliente): Observable<ProcessoCliente> {
        return this.http.put<ProcessoCliente>(this.url + id, processoCliente);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}